module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/9.3281b7ed.png";